type CookieOptions = {
  path?: string
  sameSite?: "Lax" | "Strict" | "None"
  maxAge?: number
}

export const getCookie = (key: string): string | null => {
  if (typeof document === "undefined") return null

  const cookies = document.cookie ? document.cookie.split("; ") : []
  const prefix = `${encodeURIComponent(key)}=`
  const match = cookies.find(cookie => cookie.startsWith(prefix))

  if (!match) return null

  return decodeURIComponent(match.substring(prefix.length))
}

export const setCookie = (
  key: string,
  value: string | number | boolean,
  options: CookieOptions = {}
) => {
  if (typeof document === "undefined") return

  const { path = "/", sameSite = "Lax", maxAge } = options
  const parts = [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`]

  if (maxAge) {
    parts.push(`Max-Age=${maxAge}`)
  }

  if (path) {
    parts.push(`Path=${path}`)
  }

  if (sameSite) {
    parts.push(`SameSite=${sameSite}`)
  }

  document.cookie = parts.join("; ")
}
